import { logNewRelicPageAction } from '@makemydeal/dr-activities-common';
import type { AioFSFailure } from '@makemydeal/dr-dash-store/types/types';

const SAVE_FLOW_WAIT_START = 'MV.SaveFlow.Wait.Start';
const SAVE_FLOW_WAIT_SUCCESS = 'MV.SaveFlow.Wait.Success';
const SAVE_FLOW_WAIT_TIMEOUT = 'MV.SaveFlow.Wait.Timeout';
const SAVE_FLOW_WAIT_FAILURE = 'MV.SaveFlow.Wait.Failure';

interface SaveFlowEventData {
    userId: string;
    waitTimeMs?: number;
    [key: string]: any;
}

export const recordSaveFlowStart = (data: SaveFlowEventData) => {
    logNewRelicPageAction(SAVE_FLOW_WAIT_START, {
        userId: data.userId
    });
};

export const recordSaveFlowSuccess = (data: SaveFlowEventData) => {
    logNewRelicPageAction(SAVE_FLOW_WAIT_SUCCESS, {
        userId: data.userId,
        waitTimeMs: data.waitTimeMs
    });
};

export const recordSaveFlowTimeout = (data: SaveFlowEventData) => {
    logNewRelicPageAction(SAVE_FLOW_WAIT_TIMEOUT, {
        userId: data.userId,
        waitTimeMs: data.waitTimeMs
    });
};

export const recordSaveFlowFailure = (errors: AioFSFailure[] | undefined, data: SaveFlowEventData) => {
    logNewRelicPageAction(SAVE_FLOW_WAIT_FAILURE, {
        userId: data.userId,
        waitTimeMs: data.waitTimeMs,
        ...(errors && { errorMessages: JSON.stringify(errors.map((e) => e.message || 'unknown error')) })
    });
};
